<form [formGroup]="suggestionForm" novalidate class="flex gap-2">
  <mat-form-field appearance="outline" class="flex-grow">
    <mat-label>New Names</mat-label>
    <input
      matInput
      placeholder="name_1, name_2, name_3...."
      formControlName="name"
      type="text"
      [errorStateMatcher]="matcher"
    />
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    class="!h-14"
    (click)="addName()"
    [disabled]="suggestionForm.invalid"
  >
    <mat-icon>add</mat-icon>
    ADD
  </button>
</form>
